import type {MetricType} from 'web-vitals'

const reportWebVitals = (onPerfEntry?: (metric: MetricType) => void): void => {
  if (onPerfEntry != null) {
    import("web-vitals").then(({onCLS, onINP, onFCP, onLCP, onTTFB}) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    }).catch((err: unknown) => {
      console.error('Error loading web-vitals: ' + String(err))
    })
  }
}

export default reportWebVitals
